import { Spinner } from '@/components/ui/spinner';

interface LoadingStateProps {
  label?: string;
}

export function LoadingState({ label }: LoadingStateProps): JSX.Element {
  return (
    <div className="flex items-center justify-center py-16">
      <Spinner label={label} />
    </div>
  );
}
